// src/utils/constants.js
export const COLORS = [
  "#ad3bddff",
  "#B282F9",
  "#9500D3",
  "#53b025",
  "#2729a1",
  "#c71818",
];

export const ALL_MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const ORG_VIDEO_RESPONSE = [
  "67aaf8418b96315f0fdb593e",
  "6a38cd0420d7300c20c6fbe3"
]